require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./aut-et-autem-aliquid.json") })
        }
      }, "path---aut-et-autem-aliquid");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---aut-et-autem-aliquid!./.cache/json/aut-et-autem-aliquid.json
// module id = 392
// module chunks = 231608221292675